export default __webpack_public_path__ + "static/media/INSEE-Plus-bg-on-mobile.974cbae6.jpg";